import dayjs from 'dayjs'

import {
	User,
	UserActionTypes,
	UserOrganizationEducationalContent,
} from '@app/types/user'
import { AppThunkAction } from '@app/store'
import { executeResponseError } from '@app/helpers'

import api from '../../../api'
import { getCoachData, setCoachData } from '../coaches/actions'

export const getUser = (): AppThunkAction<Promise<User | undefined>> => {
	return async dispatch => {
		try {
			const timezoneOffsetInMinutes = -dayjs().utcOffset()

			const res = await api.user.getUserData(timezoneOffsetInMinutes)

			if (res.data?.result) {
				dispatch({
					type: UserActionTypes.USER_GET,
					payload: res.data.result,
				})

				return res.data?.result
			}
		} catch (e: any) {
			const error = executeResponseError(e, 'Get user error')
			if (error) {
				throw new Error(error)
			}
		}
	}
}

export const createUser = (data: User): AppThunkAction<void> => {
	return async dispatch => {
		try {
			await api.user.createUser(data)

			await dispatch(getUser())
		} catch (e: any) {
			const error = executeResponseError(e, 'Create user error')
			throw new Error(error || '')
		}
	}
}

export const updateAnyUser = (
	data: User,
	id: string,
	other: boolean
): AppThunkAction<void> => {
	return async dispatch => {
		try {
			if (other) {
				const res = await api.coach.updateOtherUsers(data)
				if (res?.data?.result)
					await dispatch(setCoachData(res?.data?.result))
			} else {
				const res = await api.user.updateUser(data)

				if (res?.data?.result) {
					dispatch({
						type: UserActionTypes.USER_UPDATE_LOCALIZATION,
						payload: res?.data?.result?.localization,
					})
					await dispatch(getCoachData(id))
				}
			}
		} catch (e: any) {
			const error = executeResponseError(e, 'Update user error')
			throw new Error(error || '')
		}
	}
}

export const changeEduContent = (
	data: Array<UserOrganizationEducationalContent>,
	id: string
): AppThunkAction<Promise<void>> => {
	const eduContent: any = { educationalContent: data, _id: id }
	return async dispatch => {
		try {
			await api.clinic.updateOrganizationDetails(eduContent)
			await dispatch(getUser())
		} catch (e: any) {
			const error = executeResponseError(e, 'Changing content error')
			throw new Error(error || '')
		}
	}
}
